import { COOKIE_NAMES, OPTED_OUT_WELCOME_OFFER_ID } from './constants';
import { deleteCookieByName, getCookieByName, storeInCookie } from './cookies';
import { gatekeeper } from './gatekeeper';

export const setRegistrationStartNativeEvents = () => {
  gatekeeper?.messageBus?.publish('native', {
    kind:       'appLoaded',
    isLoggedIn: false,
    id:         '',
  });

  gatekeeper?.messageBus?.publish('native', {
    kind:       'onRouteLoaded',
    isLoggedIn: false,
    id:         window?.location?.pathname,
  });
};

export const extractNativeEventDataFromCookie = (cookie: string | undefined | null) => {
  if (cookie) {
    const parts = cookie.split(',');
    const result = {
      playerId:       parts[0]?.trim(),
      welcomeOfferId: parts[1]?.trim(),
    };

    return result;
  }

  return null;
};

export const setRegistrationEndNativeEvents = ({
  userId,
  woId,
  kycRequired = false,
}: {
  woId: string;
  userId: string;
  kycRequired?: boolean;
}) => {
  // This is necessary to trigger LIS playerLogin event.
  storeInCookie(COOKIE_NAMES.REGISTRATIONFORM, 'welcomeOfferId', woId);
  const optedInToWelcomeOffer = woId && woId !== OPTED_OUT_WELCOME_OFFER_ID;

  const postRegistrationRouteId = optedInToWelcomeOffer ? '/' : 'CASH_DEPOSIT';

  gatekeeper?.messageBus?.publish('native', {
    kind:                   `playerRegistered${kycRequired ? 'WithKycRequired' : ''}`,
    selectedWelcomeOfferId: woId,
    userId,
    postRegistrationRouteId,
  });
};

export const setPlayerLoginNativeEvents = ({
  userId,
  email,
  marketCode,
  sessionId,
  username,
}: {
  userId: string;
  username?: string;
  marketCode?: string;
  sessionId?: string;
  email?: string;
}) => {

  gatekeeper?.messageBus?.publish('native', {
    kind:            'playerLogin',
    id:              userId,
    username,
    marketCode,
    sessionId,
    email,
    // these 3 values are just here to avoid errors in the native app
    isSportsEnabled: false,
    password:        '',
    level:           0,
  });
};

export const initiateNativeRegistration = async () => {
  const nativeEventsCookie = getCookieByName(COOKIE_NAMES.NATIVE_EVENTS_COOKIE);
  const isFirstLoginCookie = getCookieByName(COOKIE_NAMES.FIRST_LOGIN);
  const { welcomeOfferId, playerId } = extractNativeEventDataFromCookie(nativeEventsCookie) || {};

  const tokenSet = await gatekeeper.auth.getAccessToken();

  if (!tokenSet && !nativeEventsCookie && !isFirstLoginCookie) {
    if (gatekeeper.localisation.marketSlug === 'sv') {
      setRegistrationStartNativeEvents();
      // Check why login() doesn't take any arguments
      // gatekeeper.auth.logIn({})
      gatekeeper.auth.logIn();
    }
  }

  if (nativeEventsCookie && welcomeOfferId && playerId) {
    setRegistrationEndNativeEvents({
      woId:   welcomeOfferId,
      userId: playerId,
    });
    deleteCookieByName(COOKIE_NAMES.NATIVE_EVENTS_COOKIE);
    deleteCookieByName(COOKIE_NAMES.FIRST_LOGIN);
  }
};
